import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v("Organization Maintenance"),
      ]),
      _c(
        "actions-component",
        [
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { outlined: "", dense: "" },
                  on: {
                    click: function ($event) {
                      return _vm.openDomain(null, "crear")
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-add")]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_crear"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VCard,
        [
          _c(VDataTable, {
            staticClass: "table-inca",
            attrs: {
              headers: _vm.headers,
              items: _vm.domains,
              "hide-default-footer": "",
              "items-per-page": _vm.pagination.limit,
              page: _vm.pagination.current,
            },
            on: {
              pagination: function ($event) {
                _vm.pagination.total = $event.itemsLength
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.pagination, "current", $event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "item.actions",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openDomain(item, "ver")
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("icon-view")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v("View Organization")])]
                    ),
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openDomain(
                                                item,
                                                "editar"
                                              )
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("icon-edit")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v("Edit Organization")])]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
      _c(
        "dialogs-component",
        {
          ref: _vm.DIALOG_DOMAIN,
          attrs: { title: _vm.tipo + " " + _vm.domain_aux.domain, width: 800 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VForm,
                { ref: "form" },
                [
                  _c(
                    VTabs,
                    [
                      _c(VTab, [_vm._v("General")]),
                      _c(
                        VTabItem,
                        { staticClass: "pt-3" },
                        [
                          _c(
                            VRow,
                            { attrs: { justify: "center" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Dominio")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      filled: _vm.readonly,
                                      readonly: _vm.readonly,
                                      rules: [
                                        function (v) {
                                          return (
                                            !!v || "Organization is required"
                                          )
                                        },
                                      ],
                                    },
                                    model: {
                                      value: _vm.domain_aux.domain,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.domain_aux, "domain", $$v)
                                      },
                                      expression: "domain_aux.domain",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            { attrs: { justify: "center" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Orgs")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VAutocomplete, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      filled: _vm.readonly,
                                      multiple: "",
                                      chips: "",
                                      items: _vm.selectOrganization,
                                      readonly: _vm.readonly,
                                      rules: [
                                        function (v) {
                                          return (
                                            v.length > 0 || "Orgs is required"
                                          )
                                        },
                                      ],
                                    },
                                    model: {
                                      value: _vm.domain_aux.list_orgs,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.domain_aux,
                                          "list_orgs",
                                          $$v
                                        )
                                      },
                                      expression: "domain_aux.list_orgs",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            { attrs: { justify: "center" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Alias")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      filled: _vm.readonly,
                                      readonly: _vm.readonly,
                                    },
                                    model: {
                                      value: _vm.domain_aux.alias,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.domain_aux, "alias", $$v)
                                      },
                                      expression: "domain_aux.alias",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            { attrs: { justify: "center" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Datacatalog Project ID")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      filled: _vm.readonly,
                                      readonly: _vm.readonly,
                                    },
                                    model: {
                                      value:
                                        _vm.domain_aux.datacatalog_project_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.domain_aux,
                                          "datacatalog_project_id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "domain_aux.datacatalog_project_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(VTab, [_vm._v("Credentials")]),
                      _c(
                        VTabItem,
                        { staticClass: "pt-3" },
                        [
                          _c(
                            VRow,
                            { attrs: { justify: "center" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Client Email")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      filled: _vm.readonly,
                                      readonly: _vm.readonly,
                                    },
                                    model: {
                                      value: _vm.credentials.client_email,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.credentials,
                                          "client_email",
                                          $$v
                                        )
                                      },
                                      expression: "credentials.client_email",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            { attrs: { justify: "center" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Project ID")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      filled: _vm.readonly,
                                      readonly: _vm.readonly,
                                    },
                                    model: {
                                      value: _vm.credentials.project_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.credentials,
                                          "project_id",
                                          $$v
                                        )
                                      },
                                      expression: "credentials.project_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            { attrs: { justify: "center" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Type")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      filled: _vm.readonly,
                                      readonly: _vm.readonly,
                                    },
                                    model: {
                                      value: _vm.credentials.type,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.credentials, "type", $$v)
                                      },
                                      expression: "credentials.type",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(VTab, [_vm._v("Lists")]),
                      _c(
                        VTabItem,
                        { staticClass: "pt-3" },
                        [
                          _c(
                            VRow,
                            { attrs: { justify: "center" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("List Projects")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      filled: _vm.readonly,
                                      readonly: _vm.readonly,
                                    },
                                    model: {
                                      value: _vm.domain_aux.list_projects,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.domain_aux,
                                          "list_projects",
                                          $$v
                                        )
                                      },
                                      expression: "domain_aux.list_projects",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(VTab, [_vm._v("Maintenance")]),
                      _c(
                        VTabItem,
                        { staticClass: "pt-3" },
                        [
                          _c(
                            VRow,
                            { attrs: { justify: "center" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Company ID")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      filled: _vm.readonly,
                                      readonly: _vm.readonly,
                                    },
                                    model: {
                                      value: _vm.maintenance.itc_company_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.maintenance,
                                          "itc_company_id",
                                          $$v
                                        )
                                      },
                                      expression: "maintenance.itc_company_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            { attrs: { justify: "center" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Company Name")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      filled: _vm.readonly,
                                      readonly: _vm.readonly,
                                    },
                                    model: {
                                      value: _vm.maintenance.itc_company_name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.maintenance,
                                          "itc_company_name",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "maintenance.itc_company_name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            { attrs: { justify: "center" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Company Orgs")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VCombobox, {
                                    attrs: {
                                      items: [],
                                      "hide-selected": "",
                                      outlined: !_vm.readonly,
                                      filled: _vm.readonly,
                                      readonly: _vm.readonly,
                                      multiple: "",
                                      "small-chips": "",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value:
                                        _vm.maintenance
                                          .itc_company_organizations,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.maintenance,
                                          "itc_company_organizations",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "maintenance.itc_company_organizations",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            { attrs: { justify: "center" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Industry")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      items: ["Financiera", "Retail", "Growth"],
                                      readonly: _vm.readonly,
                                    },
                                    model: {
                                      value: _vm.maintenance.itc_industry,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.maintenance,
                                          "itc_industry",
                                          $$v
                                        )
                                      },
                                      expression: "maintenance.itc_industry",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(VTab, [_vm._v("Visualization")]),
                      _c(
                        VTabItem,
                        { staticClass: "pt-3" },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(VCol, { attrs: { cols: "3" } }, [
                                _c("label", [_vm._v("Datastudio Config")]),
                              ]),
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _vm.maintenance.datastudio_config
                                    ? _c(VSwitch, {
                                        staticClass: "mt-0 pt-0",
                                        attrs: {
                                          label: "has_access",
                                          disabled: _vm.readonly,
                                        },
                                        model: {
                                          value:
                                            _vm.maintenance.datastudio_config
                                              .has_access_function,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.maintenance.datastudio_config,
                                              "has_access_function",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "maintenance.datastudio_config.has_access_function",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _vm.maintenance.datastudio_config
                                    ? _c(VSwitch, {
                                        staticClass: "mt-0 pt-0",
                                        attrs: {
                                          label: "has_datastudio",
                                          disabled: _vm.readonly,
                                        },
                                        model: {
                                          value:
                                            _vm.maintenance.datastudio_config
                                              .has_datastudio,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.maintenance.datastudio_config,
                                              "has_datastudio",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "maintenance.datastudio_config.has_datastudio",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(VCol, { attrs: { cols: "3" } }, [
                                _c("label", [_vm._v("PowerBI Config")]),
                              ]),
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _vm.maintenance.powerbi_config
                                    ? _c(VSwitch, {
                                        staticClass: "mt-0 pt-0",
                                        attrs: {
                                          label: "has_access",
                                          disabled: _vm.readonly,
                                        },
                                        model: {
                                          value:
                                            _vm.maintenance.powerbi_config
                                              .has_access_function,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.maintenance.powerbi_config,
                                              "has_access_function",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "maintenance.powerbi_config.has_access_function",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _vm.maintenance.powerbi_config
                                    ? _c(VSwitch, {
                                        staticClass: "mt-0 pt-0",
                                        attrs: {
                                          label: "has_powerbi",
                                          disabled: _vm.readonly,
                                        },
                                        model: {
                                          value:
                                            _vm.maintenance.powerbi_config
                                              .has_powerbi,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.maintenance.powerbi_config,
                                              "has_powerbi",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "maintenance.powerbi_config.has_powerbi",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _vm.maintenance.powerbi_config
                                    ? _c(VSwitch, {
                                        staticClass: "mt-0 pt-0",
                                        attrs: {
                                          label: "has_multiple_access",
                                          disabled: _vm.readonly,
                                        },
                                        model: {
                                          value:
                                            _vm.maintenance.powerbi_config
                                              .has_multiple_access,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.maintenance.powerbi_config,
                                              "has_multiple_access",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "maintenance.powerbi_config.has_multiple_access",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(VCol, { attrs: { cols: "3" } }, [
                                _c("label", [_vm._v("Tableau Config")]),
                              ]),
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _vm.maintenance.tableau_config
                                    ? _c(VSwitch, {
                                        staticClass: "mt-0 pt-0",
                                        attrs: {
                                          label: "has_access",
                                          disabled: _vm.readonly,
                                        },
                                        model: {
                                          value:
                                            _vm.maintenance.tableau_config
                                              .has_access_function,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.maintenance.tableau_config,
                                              "has_access_function",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "maintenance.tableau_config.has_access_function",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _vm.maintenance.tableau_config
                                    ? _c(VSwitch, {
                                        staticClass: "mt-0 pt-0",
                                        attrs: {
                                          label: "has_tableau",
                                          disabled: _vm.readonly,
                                        },
                                        model: {
                                          value:
                                            _vm.maintenance.tableau_config
                                              .has_tableau,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.maintenance.tableau_config,
                                              "has_tableau",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "maintenance.tableau_config.has_tableau",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _vm.maintenance.tableau_config
                                    ? _c(VSwitch, {
                                        staticClass: "mt-0 pt-0",
                                        attrs: {
                                          label: "has_multiple_access",
                                          disabled: _vm.readonly,
                                        },
                                        model: {
                                          value:
                                            _vm.maintenance.tableau_config
                                              .has_multiple_access,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.maintenance.tableau_config,
                                              "has_multiple_access",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "maintenance.tableau_config.has_multiple_access",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(VCol, { attrs: { cols: "3" } }, [
                                _c("label", [_vm._v("Bigquery Config")]),
                              ]),
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _vm.maintenance.bigquery_config
                                    ? _c(VSwitch, {
                                        staticClass: "mt-0 pt-0",
                                        attrs: {
                                          label: "has_access",
                                          disabled: _vm.readonly,
                                        },
                                        model: {
                                          value:
                                            _vm.maintenance.bigquery_config
                                              .has_access_function,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.maintenance.bigquery_config,
                                              "has_access_function",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "maintenance.bigquery_config.has_access_function",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(VTab, [_vm._v("Dataplex")]),
                      _c(
                        VTabItem,
                        { staticClass: "pt-3" },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Dataplex Project")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      readonly: _vm.readonly,
                                    },
                                    model: {
                                      value: _vm.domain_aux.dataplex_project,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.domain_aux,
                                          "dataplex_project",
                                          $$v
                                        )
                                      },
                                      expression: "domain_aux.dataplex_project",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Dataplex Table Result Profiling")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      readonly: _vm.readonly,
                                    },
                                    model: {
                                      value:
                                        _vm.domain_aux.dataplex_table_result,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.domain_aux,
                                          "dataplex_table_result",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "domain_aux.dataplex_table_result",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Dataplex Table Result Quality")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      readonly: _vm.readonly,
                                    },
                                    model: {
                                      value:
                                        _vm.domain_aux.dataplex_table_result_dq,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.domain_aux,
                                          "dataplex_table_result_dq",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "domain_aux.dataplex_table_result_dq",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(VTab, [_vm._v("Flags")]),
                      _c(
                        VTabItem,
                        { staticClass: "pt-3" },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(VCol, { attrs: { cols: "3" } }, [
                                _c("label", [_vm._v("¿MLOps Active?")]),
                              ]),
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _vm.maintenance.flags
                                    ? _c(VSwitch, {
                                        staticClass: "mt-0 pt-0",
                                        attrs: { disabled: _vm.readonly },
                                        model: {
                                          value:
                                            _vm.maintenance.flags.mlops_active,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.maintenance.flags,
                                              "mlops_active",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "maintenance.flags.mlops_active",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(VCol, { attrs: { cols: "3" } }, [
                                _c("label", [_vm._v("¿Dataplex Active?")]),
                              ]),
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _vm.maintenance.flags
                                    ? _c(VSwitch, {
                                        staticClass: "mt-0 pt-0",
                                        attrs: { disabled: _vm.readonly },
                                        model: {
                                          value:
                                            _vm.maintenance.flags
                                              .dataplex_active,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.maintenance.flags,
                                              "dataplex_active",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "maintenance.flags.dataplex_active",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c("label", [_vm._v("¿UDC Active?")]),
                                  _c(VCol, { attrs: { cols: "3" } }),
                                  _vm.maintenance.flags
                                    ? _c(VSwitch, {
                                        staticClass: "mt-0 pt-0",
                                        attrs: { disabled: _vm.readonly },
                                        model: {
                                          value:
                                            _vm.maintenance.flags.udc_active,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.maintenance.flags,
                                              "udc_active",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "maintenance.flags.udc_active",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(VCol, { attrs: { cols: "3" } }, [
                                _c("label", [_vm._v("¿Hub IA Active?")]),
                              ]),
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _vm.maintenance.flags
                                    ? _c(VSwitch, {
                                        staticClass: "mt-0 pt-0",
                                        attrs: { disabled: _vm.readonly },
                                        model: {
                                          value:
                                            _vm.maintenance.flags.hub_ia_active,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.maintenance.flags,
                                              "hub_ia_active",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "maintenance.flags.hub_ia_active",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              !_vm.readonly
                ? _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.updateDomain()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-check-circle-outline"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }